import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.03637 4.98642C6.86149 4.81163 6.57888 4.8089 6.40064 4.9803C6.2642 5.11149 6.22498 5.31183 6.29589 5.48179C6.35723 5.62879 6.44097 5.76613 6.50707 5.91109L8.467 9.91488L6.30851 14.5684L9.9516 15.6836L10.9537 9.70995L10.9635 9.67127C10.9913 9.56033 10.9993 9.49196 11 9.45083C11 9.4465 11 9.44216 11 9.43781C10.9998 9.4287 10.9993 9.4213 10.9985 9.41535C10.9559 9.07237 10.8002 8.75116 10.5533 8.50423L7.03637 4.98642ZM4.27993 14.1887L6.25157 9.93805L4.69677 6.76189C4.61945 6.58957 4.5229 6.42636 4.45013 6.25196C4.06625 5.33198 4.27432 4.25032 5.01435 3.53869C5.97781 2.61221 7.50552 2.62715 8.45067 3.5723L11.9675 7.09001C11.9784 7.10089 11.9893 7.11192 12 7.12292C12.0107 7.11192 12.0215 7.10098 12.0324 7.0901L15.5492 3.57239C16.4944 2.62724 18.0222 2.61221 18.9856 3.53869C19.7257 4.25032 19.9337 5.33198 19.5499 6.25196C19.4771 6.42636 19.3806 6.58957 19.3032 6.76189L17.7484 9.93805L19.7201 14.1887L22 14.189V21.146L12.9368 21.1458L12 15.5617L11.0632 21.1458L2 21.146L2 14.189L4.27993 14.1887ZM13 9.45082C13.0007 9.49195 13.0087 9.56032 13.0365 9.67127L13.0463 9.70995L14.0484 15.6836L17.6915 14.5684L15.533 9.91488L17.4929 5.91108C17.559 5.76612 17.6428 5.62879 17.7041 5.48179C17.775 5.31183 17.7358 5.11149 17.5994 4.9803C17.4211 4.8089 17.1385 4.81163 16.9636 4.98642L13.4468 8.50414C13.1998 8.75107 13.0441 9.07237 13.0015 9.41535C13.0007 9.42131 13.0002 9.4287 13 9.43782"}}]};

const GestureOpenFilled = Vue.extend<IconProps>({
  name: 'GestureOpenFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-open-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureOpenFilled;
